import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'unh-blocks-controls-container',
  templateUrl: './blocks-controls-container.component.html',
  styleUrls: ['./blocks-controls-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlocksControlsContainerComponent {

  @Input() editable: boolean;
  @Input() hideEditButton: boolean;
  
  @Output() editButtonClicked = new EventEmitter<boolean>();
  @Output() deleteButtonClicked = new EventEmitter<boolean>();

  editComponent() {
    this.editButtonClicked.emit(true);
  }

  deleteComponent() {
    this.deleteButtonClicked.emit(true);
  }
}
